import { render } from "./Competency.vue?vue&type=template&id=5b791120"
import script from "./Competency.vue?vue&type=script&lang=ts"
export * from "./Competency.vue?vue&type=script&lang=ts"
script.render = render

export default script